import { useEffect, useState } from 'react'

/**
 * Перерисовать доску, когда доедут шрифты.
 *
 * Имя в карточке игрока подгоняется измерением (`name.ts`), а меряется тем
 * шрифтом, который доступен в этот момент. Первая отрисовка почти всегда
 * застаёт запасной системный: Nunito приезжает файлом и подставляется позже.
 * Ширина у них разная — имя, подогнанное под запасной, после подмены вылезало
 * бы за двор, — поэтому после загрузки карточки считаются заново.
 *
 * Хук ничего не возвращает: он не сообщает состояние, а только просит
 * перерисовку. Читать нечего — измерение и так берёт текущий шрифт.
 */
export function useFontsReady(): void {
  const [, loaded] = useState(false)

  useEffect(() => {
    let alive = true

    document.fonts?.ready.then(() => {
      if (alive) loaded(true)
    })

    return () => {
      alive = false
    }
  }, [])
}
